/**
 * 采用正则格式化日期
 * @param fmt 正则格式 例如 yyyy-MM-dd hh:mm:ss
 * @param value 日期字符串或时间戳
 * @returns {*}
 */
function dateFormat(fmt, value) {
    let date;
    if(value == null || value== undefined || value == ""){
        date = new Date();
    }else{
        switch (typeof (value)) {
            //时间戳
            case 'number':
                date = new Date(value);
                break;
            case 'string':
                //兼容IE  2019-06-22T09:55:02.000+0800 >> 2019/06/22 09:55:02
                if (value.indexOf('T') != -1 && value.indexOf('+') != -1) value = value.replace(/-/g, '/').replace('T', ' ').substring(0, value.indexOf('.'))
                date = new Date(value.replace(/-/g, '/').replace('T', ' '));
                break;
            default:
                break;
        }
    }

    let ret;
    let opt = {
        "y+": date.getFullYear().toString(),        // 年
        "M+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "h+": date.getHours().toString(),           // 时
        "m+": date.getMinutes().toString(),         // 分
        "s+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        let reg = new RegExp("(" + k + ")");
        ret = reg.exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}
export const utils = {
    dateFormat:dateFormat,
}
